export enum LevelSliderEnum {
  BEGINNER = 'Beginner',
  IMPROVER = 'Improver',
  INTERMEDIATE = 'Intermediate',
  ADVANCED = 'Advanced',
  MASTER = 'Master',
}
